import { useCallback, useEffect, useRef } from 'react';

import { DOC_HEIGHT, SAFE_AREA_BOT, SAFE_AREA_TOP } from '@mopla/constants';

import { getSafeAreas } from './utils/getSafeAreas';
import { setPlatformsOnce } from './utils/setPlatformsOnce';

export interface IIntendCache {
	safeAreaTop: number;
	safeAreaBottom: number;
	docHeight: number;
}

const HTML_STYLE = document.documentElement.style;

export const useOverlayingWebView = () => {
	const cachedIntendsRef = useRef<IIntendCache>({
		safeAreaTop: 0,
		safeAreaBottom: 0,
		docHeight: 0,
	});

	if (!HTML_STYLE.getPropertyValue(SAFE_AREA_TOP)) {
		HTML_STYLE.setProperty(SAFE_AREA_TOP, 'env(safe-area-inset-top)');
	}

	if (!HTML_STYLE.getPropertyValue(SAFE_AREA_BOT)) {
		HTML_STYLE.setProperty(SAFE_AREA_BOT, 'env(safe-area-inset-bottom)');
	}

	const setStyles = useCallback(async () => {
		await setPlatformsOnce(HTML_STYLE, cachedIntendsRef);

		const { doc, top, bot } = getSafeAreas();

		const { docHeight, safeAreaTop, safeAreaBottom } = cachedIntendsRef.current;

		if (docHeight !== doc) {
			cachedIntendsRef.current.docHeight = doc;
			HTML_STYLE.setProperty(DOC_HEIGHT, `${doc}px`);
		}

		if (safeAreaTop !== top) {
			cachedIntendsRef.current.safeAreaTop = top;
			HTML_STYLE.setProperty(SAFE_AREA_TOP, `${top}px`);
		}

		if (safeAreaBottom !== bot) {
			cachedIntendsRef.current.safeAreaBottom = bot;
			HTML_STYLE.setProperty(SAFE_AREA_BOT, `${bot}px`);
		}
	}, []);

	useEffect(() => {
		setStyles();
	}, [setStyles]);

	useEffect(() => {
		window.addEventListener('resize', setStyles);
		return () => {
			window.removeEventListener('resize', setStyles);
		};
	}, [setStyles]);
};
